import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'
import { PublicInterceptor } from '../../../Base/interceptors/PublicInterceptor';

// GET SECCIONES
export const getSecciones = async () => {
    const response = await PrivateInterceptor('Payrolls/secciones', 'GET');
    return response
}

// GET DETALLES POR IdQR
export const getDetallesPorIdQR = async (IdQR) => {
    const response = await PrivateInterceptor(`Payrolls/secciones/detalles/${IdQR}`, 'GET');
    return response;
};

// GET SECCIONES
export const getSeccionesToken = async (token) => {
    const response = await PublicInterceptor('Payrolls/secciones', 'GET', undefined, token);
    return response
}